//rem自动计算
(function(doc, win) {
    var docEl = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function() {
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            // if(clientWidth>1024){
            //     docEl.style.fontSize='52.55px'
            // }else{
            //     docEl.style.fontSize=52.55 * (clientWidth / 1024) + 'px'
            // }
            docEl.style.fontSize=74 * (clientWidth / 1440) + 'px'
        };

    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);